import {Component, OnInit} from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-drawer-siple',
  templateUrl: './drawer-siple.component.html',
  styleUrls: ['./drawer-siple.component.scss']
})
export class DrawerSipleComponent implements OnInit {

  constructor(public coef: CoefService) {
  }

  ngOnInit() {
  }

}
